import classNames from 'classnames/bind';
import styles from './licenseAgreement.module.scss';
import { AppBar, Box, Typography } from '@mui/material';
import { images } from '~/assets';

const cx = classNames.bind(styles);

const LicenseAgreement = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props
  //#region Declare Hook

  //#endregion Declare Hook
  //#region Selector
  //#endregion Selector
  //#region Declare State
  //#endregion Declare State
  //#region Implement Hook
  //#endregion Implement Hook
  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box className={cx('w-full', 'h-full')}>
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='' className={cx('w-[61px] h-[62px]')} />
          <Box className={cx('h-9')}></Box>
        </Box>
      </AppBar>

      <Box className={cx('container')}>
        <Box className={cx('header')}>
          <Typography className={cx('header-title')}></Typography>
        </Box>

        <Box className={cx('content')}>
          <Box>
            <Typography variant='h5' className={cx('section-heading')} gutterBottom>
              Terms of Use and Software License Agreement
            </Typography>
          </Box>

          <Box className={cx('section')}>
            <Typography className={cx('section-paragraph')}></Typography>
            <Typography className={cx('section-paragraph')}>
              PLEASE READ CAREFULLY: By accessing or using BORCRM.com (the “Software” or “Platform”), you agree to be
              bound by this Terms of Use and Software License Agreement (“Agreement”) between you (“User” or “Licensee”)
              and [Company Name] (“Licensor”). If you do not agree to these terms, you must not use the Software.
            </Typography>
          </Box>

          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>1. Grant of License</Typography>
            <Typography className='mb-[20px]'>
              Licensor hereby grants to Licensee a non-exclusive, non-transferable, and revocable license to access and
              use the BORCRM.com platform (the “Software”) for internal business purposes only, subject to the terms and
              conditions of this Agreement.
            </Typography>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>2. License Restrictions</Typography>
            <Box className={cx('sub-section')}>
              <Typography>Licensee shall not:</Typography>
              <ul className={cx('list')}>
                <li>Reproduce, distribute, sublicense, lease, rent, or otherwise transfer the Software;</li>
                <li>
                  Reverse engineer, decompile, disassemble, or otherwise attempt to derive the source code of the
                  Software;
                </li>
                <li>Modify or create derivative works of the Software;</li>
                <li>Use the Software to provide services to third parties not affiliated with Licensee’s business;</li>
                <li>Attempt to gain unauthorized access to the Software or its related systems.</li>
              </ul>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>3. Ownership</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                All rights, title, and interest in and to the Software, including all intellectual property rights, are
                and shall remain the exclusive property of Licensor. No rights are granted to Licensee other than those
                expressly set forth in this Agreement.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>4. Access and Use</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                Licensor will provide Licensee with access credentials. Licensee is responsible for maintaining the
                confidentiality of such credentials and all activities conducted through its account(s).
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>5. Fees and Payment</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                Licensee shall pay Licensor all applicable licensing fees as outlined in the service plan or franchise
                agreement. Failure to pay any fees when due may result in suspension or termination of access to the
                Software.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>6. Term and Termination</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                This Agreement shall remain in effect until terminated by either party with 30 days' written notice or
                immediately by Licensor upon:
              </Typography>
              <ul className={cx('list')}>
                <li>Breach of this Agreement by Licensee;</li>
                <li>Termination of any associated franchise or partner agreement;</li>
                <li>Non-payment of applicable fees.</li>
              </ul>
              <Typography>
                Upon termination, Licensee shall immediately cease use of the Software and delete any stored data or
                copies, except where required by law.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>7. Confidentiality</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                Licensee agrees to maintain the confidentiality of the Software and any proprietary information
                disclosed by Licensor. This obligation shall survive termination of the Agreement.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>8. Data Ownership</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                All data entered into the Software by Licensee remains the property of Licensee. Licensor will maintain
                commercially reasonable efforts to protect data but makes no guarantees of data loss prevention. Backups
                and exports are the responsibility of the Licensee.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>9. Disclaimer of Warranties</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                The Software is provided “as-is” without warranty of any kind. Licensor disclaims all warranties,
                express or implied, including warranties of merchantability, fitness for a particular purpose, and
                non-infringement.
              </Typography>
            </Box>
          </Box>
          <Box className={cx('line')}></Box>
          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>10. Limitation of Liability</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                In no event shall Licensor be liable to Licensee for any indirect, incidental, special, or consequential
                damages, including loss of profits or data, even if advised of the possibility of such damages.
                Licensor’s total cumulative liability under this Agreement shall not exceed the amount paid by Licensee
                in the 12 months preceding the claim.
              </Typography>
            </Box>
          </Box>

          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>11. Governing Law</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                This Agreement shall be governed by and construed in accordance with the laws of the State of Colorado
                without regard to its conflict of law principles.
              </Typography>
            </Box>
          </Box>

          <Box className={cx('section')}>
            <Typography className={cx('section-title')}>12. Entire Agreement</Typography>
            <Box className={cx('sub-section')}>
              <Typography>
                This Agreement constitutes the entire understanding between the parties and supersedes all prior
                agreements, written or oral, relating to the subject matter herein. Any amendments must be in writing
                and acknowledged by both parties.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LicenseAgreement;
